import moment from 'moment';
import { startCase } from 'lodash';
import { type ILeadDemographicSectionProps } from './LeadDemographicSection';

export type LeadDemographicDataType = Array<Record<string, string>>;

export const buildLeadDemographicRequestParams = (
  action: string,
  dates: ILeadDemographicSectionProps['dates']['now'],
  range: string,
  affiliate_id: string,
  site: string,
  trafficSource: string | undefined,
  partial: string | undefined
) => {
  const startDate = moment(dates.startDate);
  const endDate = moment(dates.endDate);

  return {
    action,
    start_date: startDate.format('YYYY-MM-DD'),
    end_date: endDate.format('YYYY-MM-DD'),
    date_range: range,
    affiliate_id,
    site_id: site,
    traffic_source: trafficSource,
    partial
  };
};

export const leadDemographicColumns: Record<
  string,
  Array<Record<'name' | 'title', string>>
> = {
  Age: [
    { name: 'age_label', title: 'Age Group' },
    { name: 'percent', title: 'Percent' }
  ],
  Gender: [
    { name: 'gender', title: 'Gender' },
    { name: 'percent', title: 'Percent' }
  ],
  'Home Owner': [
    { name: 'home_owner_label', title: 'Home Owner' },
    { name: 'percent', title: 'Percent' }
  ],
  'Insurance Company': [
    { name: 'insurance_label', title: 'Insurance Company' },
    { name: 'percent', title: 'Percent' }
  ],
  'Credit Rating': [
    { name: 'credit_label', title: 'Credit Score' },
    { name: 'percent', title: 'Percent' }
  ],
  'Multi Car': [
    { name: 'multi_car_label', title: 'Multi Car' },
    { name: 'percent', title: 'Percent' }
  ],
  'Number of Pets': [
    { name: 'pet_label', title: 'Pet' },
    { name: 'percent', title: 'Percent' }
  ],
  State: [
    { name: 'state_label', title: 'State' },
    { name: 'percent', title: 'Percent' }
  ],
  'Home Type': [
    { name: 'home_type_label', title: 'Home Type' },
    { name: 'percent', title: 'Percent' }
  ],
  Device: [
    { name: 'device_label', title: 'Device' },
    { name: 'percent', title: 'Percent' }
  ]
};

export const filterLowPercent = (data: Array<{ percent: number }>) => {
  return data.filter((item) => item.percent > 1);
};

export const getLeadPercent = (data: LeadDemographicDataType) => {
  const total = Object.values(data).reduce((t, { leads }) => {
    return t + parseInt(leads, 10);
  }, 0);

  return data.map((obj) => {
    const newObj = { ...obj };

    if (newObj.insurance_label) {
      newObj.insurance_label = startCase(newObj.insurance_label);
    }
    if (newObj.credit_label) {
      newObj.credit_label = startCase(newObj.credit_label);
    }

    const percent = (parseInt(newObj.leads, 10) / total) * 100 || 0;

    return { ...newObj, percent };
  });
};
